// Mock data for Reddy Anna Book clone - sidebar pages (English only)
export const mockSportsMenu = [
  { id: 1, name: 'Cricket', icon: '🏏', active: true },
  { id: 4, name: 'Casino', icon: '🎰', active: false },
  { id: 2, name: 'Football', icon: '⚽', active: false },
  { id: 3, name: 'Tennis', icon: '🎾', active: false },
  { id: 5, name: 'Sports Book', icon: '📊', active: false },
  { id: 6, name: 'Horse Racing', icon: '🏇', active: false },
  { id: 7, name: 'Greyhound Racing', icon: '🐕', active: false },
  { id: 8, name: 'Binary', icon: '📈', active: false },
  { id: 9, name: 'Kabaddi', icon: '🤼', active: false },
  { id: 10, name: 'Politics', icon: '🗳️', active: false },
  { id: 11, name: 'Basketball', icon: '🏀', active: false },
  { id: 12, name: 'Baseball', icon: '⚾', active: false },
  { id: 13, name: 'Table Tennis', icon: '🏓', active: false },
  { id: 14, name: 'Volleyball', icon: '🏐', active: false },
  { id: 15, name: 'Ice Hockey', icon: '🏒', active: false },
  { id: 16, name: 'Rugby', icon: '🏉', active: false },
  { id: 17, name: 'Mixed Martial Arts', icon: '🥊', active: false },
  { id: 18, name: 'Darts', icon: '🎯', active: false },
  { id: 19, name: 'Futsal', icon: '⚽', active: false }
];

/**
 * Sidebar events tree: Sport → Tournaments → Events (for expand/collapse in sidebar only).
 * If a sport has no entry or empty tournaments, sidebar item acts as a direct link.
 */
export const mockSidebarEventsTree = {
  'Cricket': [
    {
      id: 'cricket-t1',
      name: 'Others',
      events: [
        { id: 'cricket-e1', name: 'Victoria v South Australia Redbacks' },
        { id: 'cricket-e2', name: 'Malaysia v Bahrain' },
        { id: 'cricket-e3', name: 'PRETORIA CAPITALS SO VS SUNRISERS EASTERN CAPE SO' },
        { id: 'cricket-e4', name: 'Delhi Champions v Rajasthan Emperors' },
        { id: 'cricket-e5', name: 'Abu Dhabi Smashers v Punjab Lions' }
      ]
    },
    {
      id: 'cricket-t2',
      name: 'Sri Lanka / T20 MCA Division F League',
      events: [
        { id: 'cricket-e6', name: 'McLarens Group v Hnb Assurance' }
      ]
    },
    {
      id: 'cricket-t3',
      name: 'Simulated Reality League / Super Smash SRL',
      events: [
        { id: 'cricket-e7', name: 'Auckland SRL V Central Districts SRL' },
        { id: 'cricket-e8', name: 'Otago SRL V Northern Districts SRL' }
      ]
    },
    {
      id: 'cricket-t4',
      name: 'International Twenty20 Matches',
      events: [
        { id: 'cricket-e9', name: 'New Zealand v South Africa' }
      ]
    },
    {
      id: 'cricket-t5',
      name: 'One Day Internationals',
      events: [
        { id: 'cricket-e10', name: 'Bangladesh v Pakistan' }
      ]
    }
  ],
  'Football': [
    {
      id: 'football-t1',
      name: 'Others',
      events: [
        { id: 'football-e1', name: 'UEFA Champions League' }
      ]
    },
    {
      id: 'football-t2',
      name: 'Australian A-League Men',
      events: [
        { id: 'football-e2', name: 'Newcastle Jets v Auckland FC' }
      ]
    },
    {
      id: 'football-t3',
      name: 'English Premier League',
      events: [
        { id: 'football-e3', name: 'Arsenal v Everton' },
        { id: 'football-e4', name: 'Chelsea v Newcastle' },
        { id: 'football-e5', name: 'West Ham v Man City' }
      ]
    },
    {
      id: 'football-t4',
      name: 'Spanish La Liga',
      events: [
        { id: 'football-e6', name: 'Real Madrid v Elche' },
        { id: 'football-e7', name: 'Barcelona v Sevilla' }
      ]
    }
  ],
  'Tennis': [
    {
      id: 'tennis-t1',
      name: 'WTA Indian Wells 2026',
      events: [
        { id: 'tennis-e1', name: 'A Sabalenka v E Rybakina' }
      ]
    },
    {
      id: 'tennis-t2',
      name: 'ATP Indian Wells 2026',
      events: [
        { id: 'tennis-e2', name: 'Carlos Alcaraz v Medvedev' },
        { id: 'tennis-e3', name: 'A Zverev v Sinner' }
      ]
    }
  ],
  'Horse Racing': [
    {
      id: 'horseracing-t1',
      name: "Today's Meetings",
      events: [
        { id: 'hr-e1', name: 'Darwin (AUS) 14th Mar (12:16)' },
        { id: 'hr-e2', name: 'Melton (AUS) 14th Mar (12:25)' },
        { id: 'hr-e3', name: 'Ascot (AUS) 14th Mar (12:37)' },
        { id: 'hr-e4', name: 'Turffontein (RSA) 14th Mar (14:50)' }
      ]
    }
  ],
  'Greyhound Racing': [
    {
      id: 'greyhound-t1',
      name: "Today's Meetings",
      events: [
        { id: 'gr-e1', name: 'Bendigo (AUS) 14th Mar (12:02)' },
        { id: 'gr-e2', name: 'The Meadows (AUS) 14th Mar (12:30)' },
        { id: 'gr-e3', name: 'Wentworth Park (AUS) 14th Mar (13:19)' },
        { id: 'gr-e4', name: 'Doncaster 14th Mar (15:41)' }
      ]
    }
  ],
  'Binary': [
    {
      id: 'binary-t1',
      name: 'Others',
      events: [
        { id: 'binary-e1', name: 'Binary / 2026/03/13' }
      ]
    }
  ],
  'Basketball': [
    {
      id: 'basketball-t1',
      name: 'Japan / B1 League',
      events: [
        { id: 'bb-e1', name: 'Yokohama B-Corsairs vs. Seahorses Mikawa' },
        { id: 'bb-e2', name: 'Ryukyu Golden Kings Okinawa vs. Nagasaki Velca' }
      ]
    }
  ],
  'Rugby': [
    {
      id: 'rugby-t1',
      name: 'Rugby Union / Super Rugby',
      events: [
        { id: 'rugby-e1', name: 'Fijian Drua vs. Brumbies' },
        { id: 'rugby-e2', name: 'Reds vs. Waratahs' }
      ]
    },
    {
      id: 'rugby-t2',
      name: 'Six Nations',
      events: [
        { id: 'rugby-e3', name: 'Ireland vs. Scotland' }
      ]
    }
  ],
  'Mixed Martial Arts': [
    {
      id: 'mma-t1',
      name: 'UFC / UFC Fight Night',
      events: [
        { id: 'mma-e1', name: 'Emmett, Josh vs. Vallejos, Kevin' },
        { id: 'mma-e2', name: 'Curtis, Chris vs. Orolbay Uulu, Myktybek' }
      ]
    }
  ],
  'Darts': [
    {
      id: 'darts-t1',
      name: 'International / Modus Super Series',
      events: [
        { id: 'darts-e1', name: 'Usher, Graham vs. Stone, Gary' },
        { id: 'darts-e2', name: 'Heneghan, Conor vs. Evans, Lee' }
      ]
    }
  ],
  'Futsal': [
    {
      id: 'futsal-t1',
      name: 'Spain / Primera Division',
      events: [
        { id: 'futsal-e1', name: 'Inter FS vs. Cordoba Futsal' },
        { id: 'futsal-e2', name: 'FC Barcelona vs. Cartagena FS' }
      ]
    }
  ]
  // Casino, Sports Book, Kabaddi, Politics, Baseball, Table Tennis, Volleyball, Ice Hockey: no tree, sidebar item is direct link
};

export const mockTopNavigation = [
  'SPORTSBOOK', 'ESPORTS', 'MIXED MARTIAL ARTS', 'GAELIC GAMES', 'VOLLEYBALL', 
  'HANDBALL', 'AUSTRALIAN RULES', 'ICE HOCKEY', 'BASKETBALL', 'BASEBALL', 
  'AMERICAN FOOTBALL', 'SNOOKER', 'TABLE TENNIS', 'CRICKET', 'SOCCER', 'TENNIS'
];

export const mockPromoBanners = [
  {
    id: 1,
    title: "ORIGINAL REDDY ANNA BOOK ID",
    subtitle: "Get 10% Bonus",
    image: "/api/placeholder/300/150",
    cta: "Join Now"
  },
  {
    id: 2, 
    title: "PLAY TOP CRASH GAMES",
    subtitle: "Win Big Daily",
    image: "/api/placeholder/300/150",
    cta: "Play Now"
  },
  {
    id: 3,
    title: "CASINO BONUS",
    subtitle: "Up to 50% Bonus",
    image: "/api/placeholder/300/150", 
    cta: "Claim Now"
  }
];

export const mockLiveMatches = {
  cricket: [
    {
      id: 1,
      team1: "North West",
      team2: "Titans", 
      time: "02/10/2025 13:30",
      status: "Live",
      odds: { back1: 1.39, lay1: 7.00, backX: 3.50, layX: 8.97, back2: 1.40, lay2: 2.42 },
      hasLive: true
    },
    {
      id: 2,
      team1: "India A", 
      team2: "Australia A",
      time: "05/10/2025 13:30",
      status: "Live", 
      odds: { back1: 1.39, lay1: 7.00, backX: 3.50, layX: 8.97, back2: 1.40, lay2: 2.42 },
      hasLive: true
    },
    {
      id: 3,
      team1: "Afghanistan",
      team2: "Bangladesh", 
      time: "05/10/2025 20:00",
      status: "Live",
      odds: { back1: 1.56, lay1: 2.76, backX: 0, layX: 0, back2: 1.57, lay2: 2.80 },
      hasLive: true
    }
  ],
  football: [
    {
      id: 4,
      team1: "Oliveirense",
      team2: "Pacos Ferreira",
      time: "05/10/2025 15:30", 
      status: "Live",
      odds: { back1: 1.65, lay1: 3.90, backX: 6.80, layX: 1.68, back2: 4.00, lay2: 7.40 },
      hasLive: true
    },
    {
      id: 5,
      team1: "FC Twente",
      team2: "Heracles",
      time: "05/10/2025 15:45",
      status: "Live",
      odds: { back1: 1.33, lay1: 6.00, backX: 11.50, layX: 1.34, back2: 6.20, lay2: 12.00 },
      hasLive: true
    }
  ],
  tennis: [
    {
      id: 6,
      team1: "Volynets",
      team2: "Golubic", 
      time: "05/10/2025 14:00",
      status: "Live",
      odds: { back1: 1.27, lay1: 4.50, back2: 1.29, lay2: 4.60 },
      hasLive: true
    },
    {
      id: 7,
      team1: "Hanfmann", 
      team2: "Djokovic",
      time: "05/10/2025 15:00",
      status: "Live",
      odds: { back1: 9.40, lay1: 1.11, back2: 9.60, lay2: 1.12 },
      hasLive: true
    }
  ]
};

export const mockGameCategories = [
  {
    id: 1,
    name: "Pool Zone",
    background: "bg-gradient-to-r from-blue-600 to-purple-600",
    image: "/api/placeholder/100/60"
  },
  {
    id: 2, 
    name: "Cricket",
    background: "bg-gradient-to-r from-green-600 to-green-700",
    image: "/api/placeholder/100/60"
  },
  {
    id: 3,
    name: "Football", 
    background: "bg-gradient-to-r from-green-500 to-green-600",
    image: "/api/placeholder/100/60"
  },
  {
    id: 4,
    name: "Tennis",
    background: "bg-gradient-to-r from-orange-500 to-red-500", 
    image: "/api/placeholder/100/60"
  },
  {
    id: 5,
    name: "Cricket Fight",
    background: "bg-gradient-to-r from-purple-600 to-pink-600",
    image: "/api/placeholder/100/60"
  },
  {
    id: 6,
    name: "FIFA CUP WINNER", 
    background: "bg-gradient-to-r from-blue-600 to-indigo-600",
    image: "/api/placeholder/100/60"
  },
  {
    id: 7,
    name: "WINNER CUP",
    background: "bg-gradient-to-r from-yellow-500 to-orange-500",
    image: "/api/placeholder/100/60"
  },
  {
    id: 8,
    name: "Kabaddi",
    background: "bg-gradient-to-r from-red-600 to-red-700", 
    image: "/api/placeholder/100/60"
  }
];

export const mockCasinoGames = [
  { id: 1, name: "Aviator", provider: "Spribe", image: "/api/placeholder/150/100" },
  { id: 2, name: "Mines", provider: "Spribe", image: "/api/placeholder/150/100" },
  { id: 3, name: "Fun Games", provider: "Various", image: "/api/placeholder/150/100" },
  { id: 4, name: "Colour Game", provider: "Royal", image: "/api/placeholder/150/100" },
  { id: 5, name: "Speed Baccarat", provider: "Live Casino", image: "/api/placeholder/150/100" },
  { id: 6, name: "Lightning Roulette", provider: "Evolution", image: "/api/placeholder/150/100" },
  { id: 7, name: "Gates of Olympus", provider: "Pragmatic", image: "/api/placeholder/150/100" },
  { id: 8, name: "Sweet Bonanza", provider: "Pragmatic", image: "/api/placeholder/150/100" },
  { id: 9, name: "Crazy Time", provider: "Evolution", image: "/api/placeholder/150/100" },
  { id: 10, name: "Mega Moolah", provider: "Microgaming", image: "/api/placeholder/150/100" }
];

export const mockUserData = {
  displayName: "Player123",
  balance: 25000.50,
  netExposure: 0,
  availableCredit: 25000.50,
  bonusWallet: 500.00
};

export const mockBetslip = {
  selections: [],
  totalStake: 0,
  totalReturn: 0
};

/**
 * Dashboard events: live and upcoming (today/tomorrow only).
 * Each event has type: 'live' | 'virtual' | 'premium' for filter tabs.
 * Odds: back/lay for 1, X (draw), 2. Icons: tv, bm, fancy.
 */
export const mockDashboardEvents = {
  Cricket: [
    { id: 'dc1', tournament: 'International Twenty20', team1: 'New Zealand', team2: 'South Africa', dateLabel: 'Today', time: '14:30', status: 'Live', type: 'live', odds: { back1: 1.85, lay1: 2.10, backX: 3.40, layX: 3.80, back2: 4.20, lay2: 4.60 }, icons: { tv: true, bm: true, fancy: true } },
    { id: 'dc2', tournament: 'One Day Internationals', team1: 'Bangladesh', team2: 'Pakistan', dateLabel: 'Today', time: '15:00', status: 'Upcoming', type: 'live', odds: { back1: 2.42, lay1: 2.64, backX: 3.25, layX: 3.55, back2: 2.98, lay2: 3.20 }, icons: { tv: true, bm: false, fancy: true } },
    { id: 'dc3', tournament: 'CSA One-Day Challenge', team1: 'Knights', team2: 'Mpumalanga Rhinos', dateLabel: 'Today', time: '13:00', status: 'Live', type: 'live', odds: { back1: 1.68, lay1: 1.85, backX: 3.75, layX: 4.10, back2: 4.80, lay2: 5.20 }, icons: { tv: false, bm: true, fancy: true } },
    { id: 'dc4', tournament: 'Simulated Reality League / Premier League SRL', team1: 'Mumbai Indians SRL', team2: 'Delhi Capitals SRL', dateLabel: 'Today', time: '18:00', status: 'Upcoming', type: 'virtual', odds: { back1: 1.72, lay1: 1.88, backX: 3.90, layX: 4.20, back2: 4.50, lay2: 5.00 }, icons: { tv: false, bm: true, fancy: true } },
    { id: 'dc5', tournament: 'Simulated Reality League / Big Bash SRL', team1: 'Adelaide Strikers SRL', team2: 'Hobart Hurricanes SRL', dateLabel: 'Today', time: '19:30', status: 'Upcoming', type: 'virtual', odds: { back1: 2.05, lay1: 2.22, backX: 3.55, layX: 3.90, back2: 3.60, lay2: 3.92 }, icons: { tv: true, bm: true, fancy: false } },
    { id: 'dc6', tournament: 'Pakistan National T20 Cup', team1: 'Sialkot Region', team2: 'Abbottabad Region', dateLabel: 'Tomorrow', time: '10:00', status: 'Upcoming', type: 'live', odds: { back1: 1.95, lay1: 2.08, backX: 3.60, layX: 3.95, back2: 3.80, lay2: 4.10 }, icons: { tv: true, bm: true, fancy: false } },
    { id: 'dc7', tournament: 'Legends League Cricket', team1: 'Mumbai Spartans', team2: 'India Tigers', dateLabel: 'Tomorrow', time: '19:30', status: 'Upcoming', type: 'premium', odds: { back1: 2.10, lay1: 2.28, backX: 3.50, layX: 3.85, back2: 3.40, lay2: 3.72 }, icons: { tv: true, bm: true, fancy: true } },
    { id: 'dc8', tournament: 'ICC T20 Americas Qualifiers', team1: 'Mexico', team2: 'Argentina', dateLabel: 'Tomorrow', time: '22:00', status: 'Upcoming', type: 'live', odds: { back1: 2.35, lay1: 2.55, backX: 3.45, layX: 3.78, back2: 3.10, lay2: 3.38 }, icons: { tv: true, bm: false, fancy: true } },
    { id: 'dc9', tournament: 'Womens T20 International', team1: 'New Zealand W', team2: 'South Africa W', dateLabel: 'Tomorrow', time: '06:30', status: 'Upcoming', type: 'live', odds: { back1: 1.88, lay1: 2.05, backX: 3.65, layX: 4.00, back2: 4.00, lay2: 4.35 }, icons: { tv: true, bm: true, fancy: true } }
  ],
  Football: [
    { id: 'df1', tournament: 'Japanese J.League', team1: 'Kashima Antlers', team2: 'Kawasaki Frontale', dateLabel: 'Today', time: '12:00', status: 'Live', type: 'live', odds: { back1: 2.20, lay1: 2.38, backX: 3.40, layX: 3.65, back2: 3.25, lay2: 3.52 }, icons: { tv: true, bm: true, fancy: true } },
    { id: 'df2', tournament: 'Chinese Super League', team1: 'Shandong Taishan', team2: 'Beijing Guoan', dateLabel: 'Today', time: '14:30', status: 'Upcoming', type: 'live', odds: { back1: 1.92, lay1: 2.06, backX: 3.55, layX: 3.90, back2: 4.00, lay2: 4.35 }, icons: { tv: true, bm: false, fancy: true } },
    { id: 'df3', tournament: 'Chinese Super League', team1: 'Zhejiang Greentown', team2: 'Shanghai Shenhua', dateLabel: 'Today', time: '15:00', status: 'Upcoming', type: 'live', odds: { back1: 2.55, lay1: 2.75, backX: 3.35, layX: 3.65, back2: 2.75, lay2: 2.98 }, icons: { tv: true, bm: true, fancy: false } },
    { id: 'df4', tournament: 'Australian A-League Men', team1: 'Newcastle Jets', team2: 'Auckland FC', dateLabel: 'Today', time: '16:45', status: 'Upcoming', type: 'live', odds: { back1: 2.42, lay1: 2.60, backX: 3.50, layX: 3.80, back2: 2.98, lay2: 3.18 }, icons: { tv: false, bm: true, fancy: true } },
    { id: 'df5', tournament: 'South Korean K League 2', team1: 'Suwon Bluewings', team2: 'Jeonnam Dragons', dateLabel: 'Today', time: '17:00', status: 'Upcoming', type: 'live', odds: { back1: 1.85, lay1: 2.02, backX: 3.70, layX: 4.05, back2: 4.20, lay2: 4.55 }, icons: { tv: false, bm: true, fancy: true } },
    { id: 'df6', tournament: 'Simulated Football', team1: 'Arsenal SRL', team2: 'Chelsea SRL', dateLabel: 'Today', time: '19:00', status: 'Upcoming', type: 'virtual', odds: { back1: 2.10, lay1: 2.26, backX: 3.60, layX: 3.95, back2: 3.50, lay2: 3.78 }, icons: { tv: true, bm: true, fancy: true } },
    { id: 'df7', tournament: 'South Korean K League 1', team1: 'Daejeon Citizen', team2: 'Gimcheon Sangmu', dateLabel: 'Tomorrow', time: '11:00', status: 'Upcoming', type: 'live', odds: { back1: 2.65, lay1: 2.84, backX: 3.30, layX: 3.60, back2: 2.75, lay2: 2.96 }, icons: { tv: true, bm: true, fancy: false } },
    { id: 'df8', tournament: 'AFC Ladies Asian Cup', team1: 'China (W)', team2: 'Chinese Taipei (W)', dateLabel: 'Tomorrow', time: '14:00', status: 'Upcoming', type: 'live', odds: { back1: 1.45, lay1: 1.58, backX: 4.50, layX: 4.90, back2: 6.50, lay2: 7.00 }, icons: { tv: true, bm: false, fancy: true } },
    { id: 'df9', tournament: 'UEFA Champions League', team1: 'Real Madrid', team2: 'Bayern Munich', dateLabel: 'Tomorrow', time: '20:00', status: 'Upcoming', type: 'premium', odds: { back1: 2.15, lay1: 2.32, backX: 3.45, layX: 3.75, back2: 3.40, lay2: 3.68 }, icons: { tv: true, bm: true, fancy: true } }
  ],
  Tennis: [
    { id: 'dt1', tournament: 'ATP Indian Wells 2026', team1: 'Carlos Alcaraz', team2: 'Medvedev', dateLabel: 'Today', time: '16:00', status: 'Live', type: 'live', odds: { back1: 1.65, lay1: 1.78, backX: 0, layX: 0, back2: 2.35, lay2: 2.55 }, icons: { tv: true, bm: true, fancy: true } },
    { id: 'dt2', tournament: 'WTA Indian Wells 2026', team1: 'A Sabalenka', team2: 'E Rybakina', dateLabel: 'Today', time: '18:30', status: 'Upcoming', type: 'live', odds: { back1: 2.10, lay1: 2.28, backX: 0, layX: 0, back2: 1.85, lay2: 2.00 }, icons: { tv: true, bm: false, fancy: true } },
    { id: 'dt3', tournament: 'ATP Indian Wells 2026', team1: 'Rinderknech', team2: 'F Auger-Aliassime', dateLabel: 'Today', time: '20:00', status: 'Upcoming', type: 'live', odds: { back1: 3.90, lay1: 4.20, backX: 0, layX: 0, back2: 1.34, lay2: 1.45 }, icons: { tv: true, bm: true, fancy: true } },
    { id: 'dt4', tournament: 'ATP Indian Wells 2026', team1: 'A Zverev', team2: 'Sinner', dateLabel: 'Tomorrow', time: '02:00', status: 'Upcoming', type: 'live', odds: { back1: 2.55, lay1: 2.78, backX: 0, layX: 0, back2: 1.58, lay2: 1.70 }, icons: { tv: true, bm: true, fancy: true } },
    { id: 'dt5', tournament: 'Challenger', team1: 'Trungelliti', team2: 'Taberner', dateLabel: 'Tomorrow', time: '14:00', status: 'Upcoming', type: 'virtual', odds: { back1: 1.79, lay1: 1.92, backX: 0, layX: 0, back2: 2.22, lay2: 2.40 }, icons: { tv: false, bm: true, fancy: false } },
    { id: 'dt6', tournament: 'Grand Slam Premium', team1: 'Djokovic', team2: 'Sinner', dateLabel: 'Tomorrow', time: '21:00', status: 'Upcoming', type: 'premium', odds: { back1: 2.20, lay1: 2.38, backX: 0, layX: 0, back2: 1.72, lay2: 1.85 }, icons: { tv: true, bm: true, fancy: true } },
    { id: 'dt7', tournament: 'WTA Indian Wells 2026', team1: 'S Zhang', team2: 'C Gauff', dateLabel: 'Tomorrow', time: '00:30', status: 'Upcoming', type: 'live', odds: { back1: 5.10, lay1: 5.50, backX: 0, layX: 0, back2: 1.23, lay2: 1.30 }, icons: { tv: true, bm: true, fancy: true } }
  ],
  'Casino Games': [
    { id: 'dca1', tournament: 'Live Casino', team1: 'Speed Baccarat', team2: '', dateLabel: 'Today', time: 'Now', status: 'Live', type: 'live', odds: { back1: 1.95, lay1: 2.05, backX: 0, layX: 0, back2: 1.98, lay2: 2.08 }, icons: { tv: true, bm: true, fancy: false } },
    { id: 'dca2', tournament: 'Live Casino', team1: 'Lightning Roulette', team2: '', dateLabel: 'Today', time: 'Now', status: 'Live', type: 'live', odds: { back1: 2.00, lay1: 2.12, backX: 0, layX: 0, back2: 1.92, lay2: 2.02 }, icons: { tv: true, bm: false, fancy: true } },
    { id: 'dca3', tournament: 'Virtual', team1: 'Aviator', team2: '', dateLabel: 'Today', time: '24/7', status: 'Live', type: 'virtual', odds: { back1: 1.50, lay1: 1.65, backX: 0, layX: 0, back2: 2.80, lay2: 3.00 }, icons: { tv: false, bm: true, fancy: true } },
    { id: 'dca4', tournament: 'Premium Slots', team1: 'Gates of Olympus', team2: '', dateLabel: 'Today', time: '24/7', status: 'Live', type: 'premium', odds: { back1: 1.88, lay1: 2.00, backX: 0, layX: 0, back2: 2.05, lay2: 2.18 }, icons: { tv: true, bm: true, fancy: true } }
  ]
};